export default "__VITE_ASSET__CSNz$2jL__"